import { useState } from "react";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import {
	XIcon,
	FacebookIcon,
	LinkedinIcon,
	WhatsappIcon,
	EmailIcon,
} from "react-share";
import { copyTextToClipboard } from "../utils/clipboard";
import { FormattedMessage } from "react-intl";

const FONT_FAMILY = '"Poppins", sans-serif';

const SpeakerShareModal = ({ speakerId, anchorEl, handleClose, speakerName }) => {
	const [copied, setCopied] = useState(false);

	if (!speakerId) return <></>;

	const url = `${window.location.origin}${
		window.location.pathname
	}?id=${speakerId}&speakerName=${encodeURIComponent(speakerName ?? "")}`;
	const encodedUrl = encodeURIComponent(url);
	const encodedTitle = encodeURIComponent(speakerName ?? "");

	const shareItems = [
		{
			label: "X",
			Icon: XIcon,
			href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
		},
		{
			label: "Facebook",
			Icon: FacebookIcon,
			href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
		},
		{
			label: "LinkedIn",
			Icon: LinkedinIcon,
			href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
		},
		{
			label: "WhatsApp",
			Icon: WhatsappIcon,
			href: `https://api.whatsapp.com/send?text=${encodeURIComponent(
				`${speakerName ?? ""} ${url}`
			)}`,
		},
		{
			label: <FormattedMessage id="share-email" />,
			Icon: EmailIcon,
			href: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
		},
	];

	const handleCopy = () => {
		copyTextToClipboard(url);
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
			handleClose();
		}, 1200);
	};

	return (
		<Menu
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={handleClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			transformOrigin={{ vertical: "top", horizontal: "left" }}
			slotProps={{
				paper: {
					sx: {
						mt: 0.5,
						minWidth: 220,
						borderRadius: "0.8em",
						boxShadow: "0 4px 20px rgba(41, 47, 59, 0.15)",
						"& .MuiMenuItem-root": {
							fontFamily: FONT_FAMILY,
							fontSize: "14px",
							py: 1,
						},
						"& .MuiListItemText-primary": {
							fontFamily: FONT_FAMILY,
							fontSize: "14px",
						},
						"& .MuiListItemIcon-root": {
							minWidth: 36,
						},
					},
				},
			}}
		>
			{shareItems.map(({ label, Icon, href }, key) => (
				<MenuItem
					key={key}
					component="a"
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					onClick={handleClose}
				>
					<ListItemIcon>
						<Icon size={24} round />
					</ListItemIcon>
					<ListItemText>{label}</ListItemText>
				</MenuItem>
			))}
			<Divider />
			<MenuItem onClick={handleCopy}>
				<ListItemIcon>
					{copied ? (
						<CheckIcon sx={{ fontSize: 20, color: "green" }} />
					) : (
						<ContentCopyIcon sx={{ fontSize: 20 }} />
					)}
				</ListItemIcon>
				<ListItemText>
					<FormattedMessage id={copied ? "link-copied" : "copy-link"} />
				</ListItemText>
			</MenuItem>
		</Menu>
	);
};

export default SpeakerShareModal;
